module.exports = __webpack_public_path__ + "img/logo-yvivre.d56ffa2d.svg";